export const environment: {
  production: boolean;
  apiUrl: string;
  googleClientId: string;
  billingLegacyUrl: string;
  apiPostmanDocumentationUrl: string;
} = {
  production: false,
  apiUrl: 'https://billing-back-v2-int-wbxslmnana-ew.a.run.app',
  googleClientId: '655059981142-a7vir942cbpeku8mpq3btbt06rmc8kum.apps.googleusercontent.com', 
  billingLegacyUrl: 'https://int.admin.billing.tecalis.dev/',
  apiPostmanDocumentationUrl: 'https://documenter.getpostman.com/view/7584499/2s8Z73xANu',
};
